module.exports = __webpack_public_path__ + "img/start-game.64e3c6cc.webp";